import React, { useRef, forwardRef, useImperativeHandle} from 'react';
import './index.scss';
import shopifyPic from '../../../../assets/shopify.jpg';
import Form, {Item, RequiredRule, PatternRule, ButtonItem, Label} from 'devextreme-react/form';
import storesApi from '../../../../api/stores';
import sessions from '../../../../sessions';

const Shopify = forwardRef((props, ref) =>{
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const onSubmit = (async(e) => {
        if(e)e.preventDefault();

        const {shopName} = formData.current;
        if(shopName){
            try {
                await storesApi.getOauth("shopify",userId,shopName,auth).then(res=>{
                    window.location.href = res.data.data;
                })
            } catch (err) {
                console.log(err);
            }
        }
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
             <div className="bridge-header">
                <img alt="shopifyPic" src={shopifyPic} className="logo-size"/>
            </div>
            <div className="shopify-bridge-content">
                <div className="bridge-content">
                    <form onSubmit={onSubmit}>
                        <Form formData={formData.current} className="form-field" labelLocation={'left'} validationGroup='group'>
                            <Item
                                dataField="shopName"
                                isRequired={true}
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                    width:200,
                                    stylingMode: 'filled',
                                    placeholder: 'my-store'
                            }}>
                                <Label text="store name"/>
                                <RequiredRule message="store name is required" />
                                <PatternRule
                                    pattern='[a-zA-Z0-9][a-zA-Z0-9\-]'
                                    message="The store name should only contain letters (a-z), numbers (0-9), dots, and hyphens."
                                />
                            </Item>
                            <ButtonItem horizontalAlignment="left"
                            //This button help to preventdefault
                            buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible:false
                            }}
                            />
                        </Form>
                    </form>
                    <span className={'shopify'}>.myshopify.com</span>
                </div>
            </div>
        </React.Fragment>
    );
})

export default Shopify;